const TreeLogo = ({ size = 40, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Tree trunk */}
      <path 
        d="M50 55 L50 75" 
        stroke="currentColor" 
        strokeWidth="6" 
        strokeLinecap="round"
      />
      
      {/* Roots */}
      <path 
        d="M50 75 L35 90" 
        stroke="currentColor" 
        strokeWidth="4" 
        strokeLinecap="round"
      />
      <path 
        d="M50 75 L50 95" 
        stroke="currentColor" 
        strokeWidth="4" 
        strokeLinecap="round"
      />
      <path 
        d="M50 75 L65 90" 
        stroke="currentColor" 
        strokeWidth="4" 
        strokeLinecap="round"
      />
      <path 
        d="M42 82 L30 92" 
        stroke="currentColor" 
        strokeWidth="3" 
        strokeLinecap="round"
      />
      <path 
        d="M58 82 L70 92" 
        stroke="currentColor" 
        strokeWidth="3" 
        strokeLinecap="round"
      />
      
      {/* Tree canopy - layered circles for organic feel */}
      <circle cx="50" cy="35" r="22" fill="currentColor" opacity="0.9" />
      <circle cx="35" cy="40" r="15" fill="currentColor" opacity="0.8" />
      <circle cx="65" cy="40" r="15" fill="currentColor" opacity="0.8" />
      <circle cx="40" cy="25" r="12" fill="currentColor" opacity="0.85" />
      <circle cx="60" cy="25" r="12" fill="currentColor" opacity="0.85" />
      <circle cx="50" cy="18" r="10" fill="currentColor" opacity="0.9" />
    </svg>
  );
};

export default TreeLogo;
